import { render, staticRenderFns } from "./SafestTradersByDrawdown.vue?vue&type=template&id=20c107c7&"
import script from "./SafestTradersByDrawdown.vue?vue&type=script&lang=js&"
export * from "./SafestTradersByDrawdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports